import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import DetailDocument from "../features/view_document/DetailDocument";

export const detailDocumentRoutes = (
    <Route
        path={ROUTES.detail_document.home}
        element={<DetailDocument />}
        key="detail_document"
    />
);
